import Button from '../../Common/Button';
import exportIcon from '../../../../assets/img/svg/buttons/export.svg';
import { useState } from 'react';
import ExportToExcel from './ExportToExcel';
import ExportToPDF from './ExportToPDF';
import { t } from 'i18next';
import { Visibility } from '../../../../enum/Visibility';

const MobileExport = () => {
  const [openDropdown, setOpenDropdown] = useState(false);

  const openExportDropdown = () => {
    setOpenDropdown((prevState) => !prevState);
  };

  return (
    <div className="export_wrapper">
      <Button
        icon={exportIcon}
        onClick={openExportDropdown}
        className="export_button_mobile"
        variant={openDropdown ? 'filled' : 'outlined'}
      />
      <div className={`export_dropdown_mobile ${openDropdown ? Visibility.VISIBLE : Visibility.HIDDEN}`}>
        <div className="excel_container">
          <ExportToExcel className="excel_mobile" filled="outline" />
          <p
            dangerouslySetInnerHTML={{
              __html: t(`statisticPage.header.export.exportAsExcel`),
            }}
          />
        </div>
        <hr />
        <div className="pdf_container">
          <ExportToPDF className="pdf_mobile" filled="outline" />
          <p
            dangerouslySetInnerHTML={{
              __html: t(`statisticPage.header.export.exportAsPDF`),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileExport;
